import {deepMerge} from "grommet/utils";
import {
    Anchor,
    Box,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Footer,
    Grid,
    Grommet,
    grommet, Heading,
    Image, Nav,
    Page,
    Text
} from "grommet";
import {
    CircleInformation,
    Gift,
    Home,
    Info,
    List,
    Logout,
    Moon,
    Qr,
    Scan,
    ShareOption,
    Shop,
    Sun,
    Tag
} from "grommet-icons";
import React, {useEffect, useState} from "react";
import AppBar from "../component/AppBar";
import CustomerDashboard from "../component/CustomerDashboard";
import {deleteRefreshToken, deleteToken, deleteUserID, getToken, getUserId} from "../utils/token";
import axios from "axios";
import QRScanner from "../component/QRScanner";
import ShopList from "../component/ShopList";
import api from "../utils/api";
import {NavLink} from "react-router-dom";
import FooterApp from "../component/Footer/FooterApp";
import HeaderApp from "../component/HeaderApp";

function handleLogout(event) {
    event.preventDefault();
    deleteToken();
    deleteRefreshToken();
    deleteUserID();
    window.location.href = '/webapp/';

}

const Stores = () => {
    const [customerInfo, setCustomerInfo] = useState({});

    const theme = deepMerge(grommet, {
        global: {
            colors: {
                brand: '#C01219',
                plain: '#C01219',
            },
            font: {
                family: "Playfair Display",
                size: "18px",
                height: "20px",
            },
        },
    });
    const [dark, setDark] = useState(false);
    return (

        <Grommet theme={theme} full={true}>

            <Box fill>
                <Box flex overflow="auto">
                    <Grid columns="medium" gap="medium" pad={"medium"}>
                        <Box
                            pad="small"
                            gap="small"
                            width="medium"
                            animation={
                                {
                                    type: "fadeIn",
                                    delay: 200,
                                    duration: 1500,
                                }
                            }>
                            <Card background="light-1"
                                  border={
                                      {
                                          color: "brand",
                                          size: "small",
                                          style: "solid",
                                      }
                                  }
                            >
                                <CardBody pad="medium">
                                    <Box direction={"row"} pad={"large"} gap={"medium"}
                                         justify={"between"}>
                                        <List
                                            size={"large"}
                                            color={"brand"}
                                        >

                                        </List>
                                        <Text
                                            alignSelf={"center"}
                                            textAlign={"center"}
                                            color={"brand"}
                                            wordBreak={"break-word"}
                                        >
                                            Scopri le offerte per te
                                        </Text>

                                    </Box>
                                </CardBody>
                            </Card>
                        </Box>
                        <Box
                            pad="small"
                            gap="small"
                            width="medium"
                            animation={
                                {
                                    type: "fadeIn",
                                    delay: 1000,
                                    duration: 1500,
                                }
                            }>
                            <Card background="light-1"
                                  border={
                                      {
                                          color: "brand",
                                          size: "small",
                                          style: "solid",
                                      }
                                  }
                            >
                                <CardBody pad="medium">
                                    <Box direction={"row"} pad={"large"} gap={"medium"}
                                         justify={"between"}>
                                        <Scan
                                            size={"large"}
                                            color={"brand"}
                                        >

                                        </Scan>
                                        <Text
                                            alignSelf={"center"}
                                            textAlign={"center"}
                                            color={"brand"}
                                            wordBreak={"break-word"}>
                                            Usa il QRCode per accumulare premi
                                        </Text>

                                    </Box>
                                </CardBody>
                            </Card>
                        </Box>
                        <Box
                            pad="small"
                            gap="small"
                            width="medium"
                            animation={
                                {
                                    type: "fadeIn",
                                    delay: 1700,
                                    duration: 1500,
                                }
                            }>
                            <Card background="light-1"
                                  border={
                                      {
                                          color: "brand",
                                          size: "small",
                                          style: "solid",
                                      }
                                  }
                            >
                                <CardBody pad="medium">
                                    <Box direction={"row"} pad={"large"} gap={"medium"}
                                         justify={"between"}>
                                        <Gift size={"large"}
                                              color={"brand"}
                                        >

                                        </Gift>
                                        <Text
                                            alignSelf={"center"}
                                            textAlign={"center"}
                                            color={"brand"}
                                            wordBreak={"break-word"}>
                                            Ritira il premio nei nostri locali
                                        </Text>

                                    </Box>
                                </CardBody>
                            </Card>
                        </Box>

                        <Heading size={"small"} alignSelf={"center"} textAlign={"center"} color={"brand"}>
                            SMART FIDELITY
                        </Heading>

                    </Grid>
                </Box>
            </Box>

        </Grommet>

    );
}

export default Stores;